import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { addCmsFaqSection } from "../../../actions/cmsFaqPageAction";

import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";

// Schema for yup
const validationSchema = Yup.object().shape({
  heading: Yup.string()
    .min(2, "Heading must have at least 2 characters")
    .max(100, "Heading can't be longer than 100 characters")
    .trim("Spaces are not allowed")
    .required("Heading is required"),
  section_type: Yup.string().trim().required("Section Type field is required"),
});

const AddFaqSection = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const onEditorChange = async (event, editor, setFieldValue) => {
    setFieldValue("content", editor.getData());
  };
  const onContentChange = async (event, editor, setFieldValue) => {
    setFieldValue("content_2", editor.getData());
  };

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/cms/faqs">
                    Faqs
                  </Link>
                  <Breadcrumb.Item active>Add</Breadcrumb.Item>
                </Breadcrumb> */}
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Add Content
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Formik
                          initialValues={{
                            heading: "",
                            content: "",
                            content_2: "",
                            link: "",
                            section_type: "",
                            question: "",
                            answer: "",
                            status: false,
                          }}
                          validationSchema={validationSchema}
                          onSubmit={async (
                            values,
                            { setSubmitting, resetForm }
                          ) => {
                            setLoader(true);

                            setSubmitting(true);
                            let res = await addCmsFaqSection(values);
                            if (res.data.success) {
                              navigate("/cms/faqs");
                              toast.success(res.data.message);
                            }
                            setLoader(false);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => (
                            <Form onSubmit={handleSubmit}>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicHeading"
                              >
                                <Form.Label>
                                  Heading <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="heading"
                                  placeholder="Enter heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.heading}
                                />
                                {touched.heading && errors.heading ? (
                                  <span
                                    className={errors.heading ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.heading}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicContent"
                              >
                                <Form.Label>Content</Form.Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={values.content ? values.content : ""}
                                  content={values.content ? values.content : ""}
                                  onChange={(event, editor) =>
                                    onEditorChange(event, editor, setFieldValue)
                                  }
                                />
                                {/* {touched.content && errors.content ? (
                                                                        <span className={errors.content ? `` : `d-none`}>
                                                                            <label className="pl-1 text-danger">{errors.content}</label>
                                                                        </span>
                                                                    ) : null} */}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicContent2"
                              >
                                <Form.Label>Content 2</Form.Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={
                                    values.content_2 ? values.content_2 : ""
                                  }
                                  content={
                                    values.content_2 ? values.content_2 : ""
                                  }
                                  onChange={(event, editor) =>
                                    onContentChange(
                                      event,
                                      editor,
                                      setFieldValue
                                    )
                                  }
                                />
                                {touched.content_2 && errors.content_2 ? (
                                  <span
                                    className={errors.content_2 ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.content_2}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicQuestion"
                              >
                                <Form.Label>Question</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="question"
                                  placeholder="Enter question"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.question}
                                />
                                {touched.link && errors.question ? (
                                  <span
                                    className={errors.question ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.question}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicAnswer"
                              >
                                <Form.Label>Answer</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="answer"
                                  placeholder="Enter answer"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.answer}
                                />
                                {touched.link && errors.answer ? (
                                  <span
                                    className={errors.answer ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.answer}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicLink"
                              >
                                <Form.Label>Link</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="link"
                                  placeholder="Enter link"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.link}
                                />
                                {touched.link && errors.link ? (
                                  <span className={errors.link ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {errors.link}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicSectionType"
                              >
                                <Form.Label>
                                  Section Display Order
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="section_type"
                                  placeholder="Enter Section Display Order"
                                  onChange={(e) => handleChange(e)}
                                />
                                {touched.section_type && errors.section_type ? (
                                  <span
                                    className={
                                      errors.section_type ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.section_type}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Row>
                                <Col md={1}>
                                  <label className="label-font">Status</label>
                                </Col>
                                <Col
                                  md={11}
                                  className="check-inline d-flex mt-3 flex-column"
                                >
                                  <label className="right-label-radio mr-3 mb-2">
                                    Active
                                    <input
                                      name="status"
                                      className="status"
                                      checked={values.status}
                                      value={values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", true)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>

                                  <label className="right-label-radio mr-3 mb-2">
                                    Inactive
                                    <input
                                      name="status1"
                                      className="status"
                                      checked={!values.status}
                                      value={!values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", false)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </Col>
                              </Row>
                              <Button className="btn-filled" type="submit">
                                Submit
                              </Button>
                            </Form>
                          )}
                        </Formik>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default AddFaqSection;
